import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

// Importa tu imagen así (recomendado):
// import heroBg from '../assets/hero-bg.jpg';

const Hero = () => {


  return (
    <section className="hero" id="inicio">
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="hero-tagline">Líderes en servicios ecológicos</p>
        <h1>
          <span className="hero-line">Compromiso.</span>
          <span className="hero-line">Sostenibilidad.</span>
          <span className="hero-line hero-line--green">Excelencia.</span>
        </h1>
        <p className="hero-description">
          Soluciones integrales de limpieza profesional y ecológica
          para empresas e instituciones en todo el Perú.
        </p>
        <div className="hero-buttons">
          <Link to="/contacto" className="hero-button-primary">
            Solicitar Cotización
          </Link>
          <Link to="/servicios" className="hero-button-secondary">
            Conocer Servicios
          </Link>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <span />
      </div>
    </section>
  );
};

export default Hero;
